import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Markdown from '@/components/Markdown';
import Image from '../../../components/ContentfulImage';

import Placeholder from '../../../components/Placeholder';
import { Wrapper, Texts, Title, SubTitle, ImageWrapper, SeasonCopyWrapper, MarkdownStyle } from './EditorialHero.style';

/**
 *「クリエーション」画面 > 各シーズンページの最上部に表示されるアピール部分 (西暦、タイトル、画像が縦並びで表示される)
 */
const EditorialHero = ({ data }) => (
  <Wrapper color={_.get(data, 'backgroundColor') || '#fff'}>
    <Texts isImageAtTheTop={data.isImageAtTheTop}>
      <SubTitle>{_.get(data, 'season') || <Placeholder h={['20px']} w={['200px']} />}</SubTitle>
      <Title isImageAtTheTop={data.isImageAtTheTop} doNotCapitalizeTheTitle={data.doNotCapitalizeTheTitle}>
        {_.get(data, 'title') || <Placeholder h={['62px']} w={['80%', '80%', '520px']} />}
      </Title>
      {/* subtitle パラメータを持たないものがある、且つ、ない場合はトリツメする必要があるため、Placeholder は、あえて非表示にしておく。 */}
      {_.get(data, 'subtitle') && <SubTitle>{data.subtitle}</SubTitle>}
    </Texts>

    <ImageWrapper isImageAtTheTop={data.isImageAtTheTop}>
      {_.get(data, 'image') ? (
        <Image src={data.image} options={{ w: '100%', size: [560, 860, 815, 1000] }} />
      ) : (
        <Placeholder w="100%" pb="60%" />
      )}
    </ImageWrapper>

    {/* seasonCopy パラメータを持たないものがある、且つ、ない場合はトリツメする必要があるため、Placeholder は、あえて非表示にしておく。 */}
    {_.get(data, 'seasonCopy') && (
      <SeasonCopyWrapper className="pc" isImageAtTheTop={data.isImageAtTheTop}>
        <Markdown Component={MarkdownStyle} src={data.seasonCopy} />
      </SeasonCopyWrapper>
    )}
  </Wrapper>
);

EditorialHero.propTypes = {
  data: PropTypes.shape({}).isRequired,
};

export default EditorialHero;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/EditorialHero/EditorialHero.js